import { Link } from 'react-router-dom';

import styled from 'styled-components';

import Spacer from 'shared/layout/Spacer';

import { useStore } from 'models/stores';

export default function Job404() {
  const { uiStore, companyStore } = useStore();
  const company = companyStore.current.name;
  const jobListUrl = `/${company}/${uiStore.language}`;

  return (
    <Wrapper>
      <Spacer top={30} bottom={30}>
        <Emoji>
          <span role="img" aria-label="not-found">
            👀
          </span>
        </Emoji>
        <Header>{uiStore.t('job_does_not_exist_header')}</Header>
        <SubHeader>{uiStore.t('job_does_not_exist_sub_header')}</SubHeader>
        <BackLink>
          <Link to={jobListUrl}>{uiStore.t('job_does_not_exist_link')}</Link>
        </BackLink>
      </Spacer>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  margin: 0 auto;
  width: 100%;
  text-align: center;
  font-weight: normal;
  font-family: ${(props) => props.theme.fontFamily};
  padding: 40px 0;
  max-width: 580px;
  @media (max-width: 720px) {
    padding: 40px;
  }

  @media (max-width: 460px) {
    padding: 40px 20px;
  }
`;

const Emoji = styled.div`
  font-size: 32px;
  line-height: 40px;
  margin-bottom: 10px;
`;

const Header = styled.div`
  font-size: 28px;
  line-height: 32px;
  color: ${(props) => props.theme.purple80};
`;

const SubHeader = styled.div`
  font-size: 16px;
  line-height: 24px;
  color: ${(props) => props.theme.purple50};
  margin-bottom: 20px;
`;

const BackLink = styled.div`
  font-size: 16px;
  line-height: 24px;
  color: ${(props) => props.theme.greenMain};
`;
